// @flow
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import '../plugins/jquery.dhtmlnumber';

export default class NumberInput extends WebComponent {
  enterDocument() {
    $(this.element).dhtmlNumber({
	    changeEvent: 'change',
    });

  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/NumberInput.js